<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="剧本id" prop="scriptId" >
        <a-input v-model="form.scriptId" placeholder="请输入剧本id" />
      </a-form-model-item>
      <a-form-model-item label="店铺id" prop="shopId" >
        <a-input v-model="form.shopId" placeholder="请输入店铺id" />
      </a-form-model-item>
      <a-form-model-item label="类型 1.测本券 2.预购券" prop="type" >
      </a-form-model-item>
      <a-form-model-item label="起始时间" prop="startTime" >
        <a-date-picker style="width: 100%" v-model="form.startTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item label="截止时间" prop="endTime" >
        <a-date-picker style="width: 100%" v-model="form.endTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item label="状态 0.未使用 1.已使用" prop="status" >
      </a-form-model-item>
      <a-form-model-item label="逻辑删除标记 1:删除,0:未删除" prop="isDeleted" >
        <a-input v-model="form.isDeleted" placeholder="请输入逻辑删除标记 1:删除,0:未删除" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入备注" />
      </a-form-model-item>
      <a-form-model-item label="版本号" prop="version" >
        <a-input v-model="form.version" placeholder="请输入版本号" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getShopCoupon, addShopCoupon, updateShopCoupon } from '@/api/played/shopCoupon'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        scriptId: null,
        shopId: null,
        type: null,
        startTime: null,
        endTime: null,
        status: 0,
        createTime: null,
        creator: null,
        updateTime: null,
        modifier: null,
        isDeleted: null,
        remark: null,
        version: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        scriptId: [
          { required: true, message: '剧本id不能为空', trigger: 'blur' }
        ],
        shopId: [
          { required: true, message: '店铺id不能为空', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '类型 1.测本券 2.预购券不能为空', trigger: 'change' }
        ],
        startTime: [
          { required: true, message: '起始时间不能为空', trigger: 'blur' }
        ],
        endTime: [
          { required: true, message: '截止时间不能为空', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '状态 0.未使用 1.已使用不能为空', trigger: 'blur' }
        ],
        isDeleted: [
          { required: true, message: '逻辑删除标记 1:删除,0:未删除不能为空', trigger: 'blur' }
        ],
        remark: [
          { required: true, message: '备注不能为空', trigger: 'blur' }
        ],
        version: [
          { required: true, message: '版本号不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        scriptId: null,
        shopId: null,
        type: null,
        startTime: null,
        endTime: null,
        status: 0,
        createTime: null,
        creator: null,
        updateTime: null,
        modifier: null,
        isDeleted: null,
        remark: null,
        version: null
      }
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getShopCoupon(id).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateShopCoupon(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addShopCoupon(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
